import { render, staticRenderFns } from "./PublishPopover.vue?vue&type=template&id=f2a619de&scoped=true&"
import script from "./PublishPopover.vue?vue&type=script&lang=js&"
export * from "./PublishPopover.vue?vue&type=script&lang=js&"
import style0 from "./PublishPopover.vue?vue&type=style&index=0&id=f2a619de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a619de",
  null
  
)

export default component.exports